<template>
  <transition name="trial-modal">
    <div
      v-if="trial_expired_modal"
      cy="trial-expired-modal"
      class="trial-modal-root"
    >
      <div
        cy="trial-modal-overlay"
        class="trial-modal-overlay"
        @click.self.prevent
      />
      <div class="trial-modal-card" role="dialog" aria-modal="true" aria-labelledby="trial-modal-title">
        <img
          cy="trial-modal-logo"
          class="trial-modal-logo"
          :src="logo"
          alt="ASP"
        />

        <!-- STEP 1: initial -->
        <div v-if="step === 'initial'">
          <h2 cy="trial-modal-title" id="trial-modal-title" class="trial-modal-title">
            Versiunea gratuită cu 10 intrări a expirat.
          </h2>

          <p cy="trial-modal-subtitle" class="trial-modal-subtitle">
            Sperăm că ASP te-a ajutat să te miști mai repede și să elimini munca repetitivă din service. Dacă da, atunci:
          </p>

          <button
            cy="trial-modal-cta-activate"
            class="trial-modal-cta trial-modal-cta--primary"
            type="button"
            :disabled="isLoading"
            @click="onActivate"
          >
            <span v-if="!isLoading">ACTIVEAZĂ ABONAMENTUL ASP</span>
            <span v-else cy="trial-modal-spinner" class="trial-modal-spinner" aria-label="Se trimite" />
          </button>

          <button
            cy="trial-modal-cta-decline"
            class="trial-modal-cta trial-modal-cta--secondary"
            type="button"
            :disabled="isLoading"
            @click="onDecline"
          >
            NU MULȚUMESC
          </button>
        </div>

        <!-- STEP 2: feedback -->
        <div v-else-if="step === 'feedback'">
          <p cy="trial-modal-feedback-label" class="trial-modal-subtitle trial-modal-subtitle--label">
            Spune-ne de ce pentru a ne ajuta să îmbunătățim ASP:
          </p>

          <textarea
            cy="trial-modal-feedback-textarea"
            class="trial-modal-textarea"
            :class="{ 'trial-modal-textarea--error': showError }"
            v-model="feedbackText"
            :disabled="isLoading"
            rows="4"
            placeholder=""
            @input="onFeedbackInput"
          />

          <p
            v-if="showError"
            cy="trial-modal-feedback-error"
            class="trial-modal-feedback-error"
          >
            Te rugăm să scrii un motiv înainte de a trimite.
          </p>

          <button
            cy="trial-modal-feedback-send"
            class="trial-modal-cta trial-modal-cta--primary"
            type="button"
            :disabled="isLoading"
            @click="onFeedbackSend"
          >
            <span v-if="!isLoading">TRIMITE</span>
            <span v-else cy="trial-modal-spinner" class="trial-modal-spinner" aria-label="Se trimite" />
          </button>

          <button
            cy="trial-modal-feedback-back"
            class="trial-modal-cta trial-modal-cta--secondary"
            type="button"
            :disabled="isLoading"
            @click="onFeedbackBack"
          >
            ÎNAPOI
          </button>
        </div>

        <!-- STEP 3: thanks (upgrade) -->
        <div v-else-if="step === 'thanks_upgrade'" cy="trial-modal-thanks-upgrade">
          <p class="trial-modal-title trial-modal-title--thanks">
            Mulțumim!
          </p>
          <p class="trial-modal-subtitle">
            Te contactăm în cel mai scurt timp pentru detaliile de facturare.
          </p>
          <button
            cy="trial-modal-ok"
            class="trial-modal-cta trial-modal-cta--primary"
            type="button"
            @click="closeModal"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import logo from '@/assets/logo.svg'

export default {
  name: 'TrialExpiredModal',
  data () {
    return {
      logo,
      step: 'initial',
      feedbackText: '',
      isLoading: false,
      showError: false
    }
  },
  computed: {
    ...mapState({
      trial_expired_modal: state => state.trial_expired_modal
    })
  },
  watch: {
    trial_expired_modal (open) {
      if (open) {
        this.step = 'initial'
        this.feedbackText = ''
        this.isLoading = false
        this.showError = false
      }
    }
  },
  methods: {
    async onActivate () {
      if (this.isLoading) return
      this.isLoading = true
      try {
        await this.$store.dispatch('post_slack_message', {
          message: 'Vreau sa upgrade',
          end_trial: true
        })
        this.step = 'thanks_upgrade'
      } catch (e) {
        this.$toast && this.$toast.error
          && this.$toast.error('Eroare trimitere mesaj. Te rugăm să încerci din nou.')
      } finally {
        this.isLoading = false
      }
    },
    onDecline () {
      if (this.isLoading) return
      this.step = 'feedback'
      this.showError = false
    },
    onFeedbackInput () {
      if (this.showError && (this.feedbackText || '').trim()) {
        this.showError = false
      }
    },
    async onFeedbackSend () {
      if (this.isLoading) return
      const text = (this.feedbackText || '').trim()
      if (!text) {
        this.showError = true
        return
      }
      this.showError = false
      this.isLoading = true
      try {
        await this.$store.dispatch('post_slack_message', {
          message: text,
          end_trial: false
        })
      } catch (e) {
        // feedback nu e critic — închidem oricum
      } finally {
        this.isLoading = false
        this.closeModal()
      }
    },
    onFeedbackBack () {
      if (this.isLoading) return
      this.feedbackText = ''
      this.showError = false
      this.step = 'initial'
    },
    closeModal () {
      this.$store.commit('SET_TRIAL_EXPIRED_MODAL', false)
    }
  }
}
</script>

<style lang="less">
@media only screen and (min-width: 0) {
  .trial-modal-root {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }

  .trial-modal-overlay {
    position: absolute;
    inset: 0;
    background: rgba(8, 11, 20, 0.62);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }

  .trial-modal-card {
    position: relative;
    width: 100%;
    max-width: 480px;
    background: #0F172A;
    color: #F8FAFC;
    border-radius: 15px;
    padding: 36px 28px 28px;
    box-shadow:
      0 24px 60px rgba(0, 0, 0, 0.55),
      0 2px 8px rgba(0, 0, 0, 0.35),
      inset 0 0 0 1px rgba(255, 255, 255, 0.06);
    text-align: center;
  }

  .trial-modal-logo {
    display: block;
    margin: 0 auto 20px;
    height: 48px;
    width: auto;
    filter: brightness(0) invert(1);
    opacity: 0.95;
  }

  .trial-modal-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
    margin: 0 0 12px;
    color: #F8FAFC;
    letter-spacing: -0.01em;
  }

  .trial-modal-title--thanks {
    font-size: 24px;
    margin-bottom: 14px;
  }

  .trial-modal-subtitle {
    font-size: 14.5px;
    line-height: 1.55;
    font-weight: 500;
    color: #b7c4d5;
    margin: 0 0 26px;
  }

  .trial-modal-subtitle--label {
    text-align: left;
    margin-bottom: 10px;
  }

  .trial-modal-textarea {
    width: 100%;
    min-height: 110px;
    resize: vertical;
    padding: 12px 14px;
    margin-bottom: 18px;
    font: inherit;
    font-size: 14.5px;
    line-height: 1.5;
    color: #F8FAFC;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    outline: none;
    transition: border-color 140ms ease, background 140ms ease, box-shadow 140ms ease;

    &::placeholder {
      color: #64748b;
    }

    &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.06);
      border-color: rgba(255, 255, 255, 0.18);
    }

    &:focus {
      border-color: #16A34A;
      box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.18);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .trial-modal-textarea--error {
    border-color: #DC2626;
    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.18);

    &:focus {
      border-color: #DC2626;
      box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.25);
    }
  }

  .trial-modal-feedback-error {
    margin: -8px 0 14px;
    text-align: left;
    color: #FCA5A5;
    font-size: 13px;
    line-height: 1.4;
  }

  .trial-modal-cta {
    width: 100%;
    min-height: 48px;
    border: none;
    border-radius: 8px;
    padding: 14px 18px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 140ms ease, background-color 140ms ease, box-shadow 140ms ease, opacity 140ms ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:active:not(:disabled) {
      transform: scale(0.985);
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }

    &:focus-visible {
      outline: 2px solid #86EFAC;
      outline-offset: 2px;
    }
  }

  .trial-modal-cta--primary {
    color: white;
    background: #16A34A;

    &:hover:not(:disabled) {
      background: rgba(22, 163, 74, 0.85);
    }
  }

  .trial-modal-cta--secondary {
    margin-top: 10px;
    color: #cbd5e1;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.14);

    &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.04);
      color: #F8FAFC;
    }
  }

  .trial-modal-spinner {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-top-color: white;
    border-radius: 50%;
    animation: trial-modal-spin 0.8s linear infinite;
  }
}

@keyframes trial-modal-spin {
  to { transform: rotate(360deg); }
}

// Subtle Apple-style entrance: backdrop fade + card scale-up with ease-out-expo
.trial-modal-enter-active,
.trial-modal-leave-active {
  transition: opacity 280ms cubic-bezier(0.16, 1, 0.3, 1);

  .trial-modal-card {
    transition:
      transform 320ms cubic-bezier(0.16, 1, 0.3, 1),
      opacity 280ms cubic-bezier(0.16, 1, 0.3, 1);
  }
}

.trial-modal-enter,
.trial-modal-leave-to {
  opacity: 0;

  .trial-modal-card {
    opacity: 0;
    transform: scale(0.94) translateY(8px);
  }
}

.trial-modal-enter-to,
.trial-modal-leave {
  opacity: 1;

  .trial-modal-card {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .trial-modal-enter-active,
  .trial-modal-leave-active,
  .trial-modal-enter-active .trial-modal-card,
  .trial-modal-leave-active .trial-modal-card {
    transition: none;
  }
}
</style>
